import React, { FunctionComponent, ReactNode, useState } from 'react'
import { Layout } from 'antd'
import LeftSider from './LeftSider/LeftSider'
import HomeMenu from './HomeMenu/HomeMenu'

const { Content } = Layout

interface IProps {
  children?: ReactNode | ReactNode[]
}

const Home: FunctionComponent<any> = (props: IProps) => {

  const [selectedKey, setSelectedKey] = useState<string>('')

  return (
    <Layout hasSider={true}>
      <HomeMenu setSelectedKey={setSelectedKey} selectedKey={selectedKey} />
      <Layout>
        <LeftSider selectedKey={selectedKey} setSelectedKey={setSelectedKey} />
        <Content>{props.children}</Content>
      </Layout>
    </Layout>
  )
}

export default Home
